import React, { useState, useEffect } from 'react';
import { getApi } from '../../api/endpoints.js';
import { useNavigate, useParams} from 'react-router-dom';
import FormPartial from './FormPartial.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import { toast } from 'react-toastify';
import LeaseOffer from '../../models/LeaseOffer.js';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';

const New = () => {
  let leaseOfferObj = new LeaseOffer();
  const [leaseOffer, setLeaseOffer] = useState(leaseOfferObj.toStateJson());
  const [createApi] = getApi('createLeaseOffer')
  const navigate = useNavigate();
  const params = useParams();

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      toast.success("Lease Offer created successfully")
      navigate(-1)
    } catch (error) {
      leaseOfferObj = new LeaseOffer(leaseOfferObj);
      leaseOfferObj.set_api_errors(error.data.data.errors);
      setLeaseOffer(leaseOfferObj.toStateJson())
      toast.error("Lease Offer not created")
    }
  }

  useEffect(()=>{
    setLeaseOffer((prevState)=>{
      return { ...prevState, user_id: params.fleet_owner_id }
    })
  }, [])

  const handleSubmitFunction = () => {
    try{
      createRecord(new LeaseOffer(leaseOffer).toApiJson());  
    } catch (e) {
      toast.error("Something went wrong")
    }
  }

  const handleCancelFunction = () => {
    navigate(-1);
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewLeaseOfferPage.name)}
    breadcrumbs={[
      { label: "Home", url: '/dashboard' }, { label: "Fleet Owners", url: `/fleet_owners` },
      { label: `${params.fleet_owner_id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `Lease Offers`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: "New" }
    ]}
    className={'new-lease-offer-page'}
  >
    <PageContentWrapper contentHeading={"Generate New Lease Offer"}>
      <div className='m-3'>
        <div className='mb-4 col-md-12'>
          <form className="row g-3" autoComplete="off">
            <FormPartial leaseOffer={leaseOffer} setLeaseOffer={setLeaseOffer} />
            <div className='mb-4 col-md-12'>
              <div >
                <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create Lease Offer</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </PageContentWrapper>
  </Page>
}
export default New;
